import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var s = {
  margin: ["margin", t],
  marginStart: ["marginLeft", t],
  marginEnd: ["marginRight", t],
  marginTop: ["marginTop", t],
  marginBottom: ["marginBottom", t],
  marginX: [["marginLeft", "marginRight"], t],
  marginY: [["marginTop", "marginBottom"], t],
  width: ["width", t],
  height: ["height", t],
  minWidth: ["minWidth", t],
  minHeight: ["minHeight", t],
  maxWidth: ["maxWidth", t],
  maxHeight: ["maxHeight", t],
  isHidden: ["display", h],
  alignSelf: ["alignSelf", n],
  justifySelf: ["justifySelf", n],
  position: ["position", t],
  zIndex: ["zIndex", t],
  top: ["top", t],
  bottom: ["bottom", t],
  start: ["left", t],
  end: ["right", t],
  order: ["order", t],
  flex: ["flex", u],
  flexGrow: ["flexGrow", n],
  flexShrink: ["flexShrink", n],
  flexBasis: ["flexBasis", n],
  gridArea: ["gridArea", n],
  gridColumn: ["gridColumn", n],
  gridColumnEnd: ["gridColumnEnd", n],
  gridColumnStart: ["gridColumnStart", n],
  gridRow: ["gridRow", n],
  gridRowEnd: ["gridRowEnd", n],
  gridRowStart: ["gridRowStart", n]
};
function u(i) {
  return typeof i == "boolean" ? i ? "1" : void 0 : "" + i;
}
function t(i) {
  return typeof i == "number" ? i + "px" : i;
}
function h(i) {
  return i ? "none" : void 0;
}
function n(i) {
  return i;
}
function c(i, e) {
  var m;
  var r = {};
  var g = {};
  return i && ((m = Object == null ? void 0 : Object.keys(i)) == null || m.forEach(function (o) {
    if (e[o]) {
      var _e$o = _slicedToArray(e[o], 2),
        a = _e$o[0],
        l = _e$o[1],
        d = l(i[o]);
      Array.isArray(a) ? a.forEach(function (f) {
        r = _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, f, d));
      }) : r = _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, a, d));
    } else g[o] = i[o];
  })), {
    componentProps: g,
    style: r
  };
}
function x(i) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : s;
  var _c = c(i || {}, e),
    r = _c.style,
    g = _c.componentProps;
  return {
    styleProps: {
      style: r
    },
    componentProps: g
  };
}
export { s as baseStyleProps, t as dimensionValue, x as useStyleProps };